import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { Factor } from '~/features/factor/types/factor.type';

/**
 * Factor 목록 조회
 * @description Factor 목록을 조회합니다
 * @endpoint GET /admin/factors
 * @returns Factor 배열
 */
export function getFactorListApi() {
  return axiosInstance.get<ApiResponse<Factor[]>>('/admin/factors');
}
